module.exports = __webpack_public_path__ + "img/icon-arrow-up-20@3x.7359e456.png";